import React from 'react';
import AcquisitionOption from './AcquisitionOption';

import { useLocationContext } from '../../context/LocationContext';

export default function PickUpOption() {
  const {
    pickUpInfoToDisplay,
    isDeliveryAllowed = true,
    isMeetupAllowed = false
  } = useLocationContext();
  const { pickupLocation, milesToPickupLocation } = pickUpInfoToDisplay ?? {};

  const pickupInfo = ` ${pickupLocation?.city}, ${pickupLocation?.state} (${milesToPickupLocation} miles away)`;

  const dividerClasses =
    isDeliveryAllowed || isMeetupAllowed
      ? 'm:first:border-0 m:first:border-r m:first:border-grey-2 m:first:border-solid'
      : '';

  return (
    <AcquisitionOption
      conditionalClasses={dividerClasses}
      title="pick up"
      text={`The nearest pickup location is ${pickupInfo}.`}
    />
  );
}
